"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _emotionTheming = require("emotion-theming");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var s = _interopRequireWildcard(require("./FloatingNotification.style"));

function unmount(node) {
  _reactDom.default.unmountComponentAtNode(node);

  node && node.parentNode.removeChild(node);
}

function show(render) {
  return new Promise(function (resolve) {
    var container = document.createElement('div');
    document.body.appendChild(container);

    function onCancel() {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      unmount(container);
      resolve(response);
    }

    var left = Math.floor(Math.random() * (90 - 75 + 1)) + 75;
    setTimeout(function () {
      return onCancel();
    }, 9000);

    var _render = render(),
        children = _render.children;

    _reactDom.default.render(_react.default.createElement(_emotionTheming.ThemeProvider, {
      theme: _themeConfig.default
    }, _react.default.createElement("div", {
      className: s.floatingNotification(left)
    }, children)), container);
  });
}

var FloatingNotification = {
  show: show
};
var _default = FloatingNotification;
exports.default = _default;